import { Tab, Tooltip } from "@mui/material";

const ModuleLockedTab = ({ label, locked, lockMessage, sx, ...tabProps }) => (
  <Tab
    {...tabProps}
    disabled={Boolean(locked)}
    label={
      locked ? (
        <Tooltip title={lockMessage || "Save the record first to unlock this tab"}>
          <span>{label}</span>
        </Tooltip>
      ) : (
        label
      )
    }
    sx={{
      ...(locked ? { "&.Mui-disabled": { pointerEvents: "auto" } } : null),
      ...sx,
    }}
  />
);

export default ModuleLockedTab;
